import { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Tabs, Tab, Button, Grid2, Box, useTheme } from '@mui/material';
import useAuth from 'hooks/useAuth';
import GetStartedBanner from '../../assets/images/GetStarted.png';
import { ArrowDown2, TickCircle } from 'iconsax-react';
import { getDemoVideo } from 'services/auth.service';
import { useNavigate } from 'react-router-dom';
import { completeGetStartedVideo } from 'services/user.service';
import Snackbar from 'utils/Snackbar';

const GetStarted = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user, updateOnboardingStatus }: any = useAuth();

  const permissions = user?.userTypeId?.permission;

  const [expandedAccordion, setExpandedAccordion] = useState<any>(false);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: any, newValue: any) => {
    setActiveTab(newValue);
  };
  const CompleteVideo = (title: string) => {
    let reqData;
    if (title === 'userTypes') {
      reqData = {
        module: 'userTypes',
        completed: true
      };
    }
    if (title === 'classroom') {
      reqData = {
        module: 'classroom',
        completed: true
      };
    }
    if (title === 'users') {
      reqData = {
        module: 'users',
        completed: true
      };
    }
    if (title === 'categories') {
      reqData = {
        module: 'categories',
        completed: true
      };
    }
    if (title === 'courses') {
      reqData = {
        module: 'courses',
        completed: true
      };
    }
    if (title === 'certificates') {
      reqData = {
        module: 'certificates',
        completed: true
      };
    }
    if (title === 'questions') {
      reqData = {
        module: 'questions',
        completed: true
      };
    }
    if (title === 'exam') {
      reqData = {
        module: 'exam',
        completed: true
      };
    }
    if (title === 'contest') {
      reqData = {
        module: 'contest',
        completed: true
      };
    }
    completeGetStartedVideo(reqData)
      .then((res) => {
        if (res.status === 200) {
          updateOnboardingStatus(res.data?.data?.onboardingStatus);
          Snackbar('Completed successfully!!', 'success');
        } else {
          Snackbar(res?.data?.message, 'error');
        }
      })
      .catch((err) => {
        Snackbar(err.response.data.message, 'error');
      });
  };
  const accordionData = [
    {
      type: 'userTypes',
      title: 'Add Permissions from User Types',
      video: 'omfmef4nn9hsn5zgwdzs',
      what: 'This step involves assigning specific permissions or access rights to different user roles or types within the system (e.g., Admin, Teacher, Student).',
      why: 'Different users have different responsibilities and access needs. By defining and assigning permissions, you ensure that users only have access to the features and data relevant to their roles, enhancing security and preventing unauthorized access.',
      how: "Navigate to the 'Permissions' section in the settings, select the user type, and assign relevant permissions from the list. Click 'Save' to apply.",
      link: '/permissions/add',
      permissionView: permissions?.UserTypes?.View,
      permissionCreate: permissions?.UserTypes?.Create
    },
    {
      type: 'users',
      title: 'Add User',
      video: 'vsvmen2ffypf6cua65a4',
      what: 'This step involves adding users (e.g., students, teachers, admins) to the system, assigning them roles, and providing them with access credentials.',
      why: 'Users need to be registered in the system to access the features and participate in academic activities. Adding users is essential to give them the necessary permissions and roles within the platform.',
      how: "Go to 'User Management', click on 'Add User', fill out the user's information, and assign a role. Click 'Save' to add the user.",
      link: '/users/add',
      permissionView: permissions?.Users?.View,
      permissionCreate: permissions?.Users?.Create
    },
    {
      type: 'categories',
      title: 'Add Category',
      video: 'Creating_category_voaivb',
      what: 'This involves creating categories to organize content, courses, or other educational materials within the system.',
      why: ' Categorizing content makes it easier for users to find relevant materials and for administrators to manage resources effectively. It also helps in structuring the curriculum in a more organized manner.',
      how: "Click on 'Add Category', input the category name and description, and click 'Save' to add it to the list.",
      link: '/category/add',
      permissionView: permissions?.Categories?.View,
      permissionCreate: permissions?.Categories?.Create
    },
    {
      type: 'courses',
      title: 'Add Courses, Adding Sections and Content',
      video: 'cjcenwk05o8s4anlt6aj',
      what: 'This step involves creating courses, dividing them into sections, and adding the relevant content for each section.',
      why: 'Courses are the core of the educational experience. By structuring them into sections with specific content, you make learning more manageable and ensure that students can follow a logical progression through the material.',
      how: "Go to 'Courses', click 'Add Course', fill in the details, and add sections and related content. Save to publish the course.",
      link: '/course/add',
      permissionView: permissions?.Courses?.View,
      permissionCreate: permissions?.Courses?.Create
    },
    {
      type: 'certificates',
      title: 'Add Certificate',
      video: 'hurmhoelihi7lmoez2sm',
      what: 'This involves creating and setting up certificates that will be awarded to students upon successful completion of a course or program.',
      why: 'Certificates provide recognition for students efforts and achievements. They are a motivational tool and an official record of accomplishments that students can use for further studies or career advancement.',
      how: "Click 'Certificates', choose 'Add Certificate', upload the template, and customize the text. Save the certificate for future use.",
      link: '/certificate/add',
      permissionView: permissions?.Certificates?.View,
      permissionCreate: permissions?.Certificates?.Create
    },
    {
      type: 'questions',
      title: 'Add Question Bank',
      video: 'f93dfwlreewamipdwztx',
      what: 'This step involves creating a repository of questions that can be used for quizzes, exams, and other assessments.',
      why: 'A question bank allows for efficient creation of assessments by reusing and organizing questions. It ensures consistency in the evaluation process and helps in maintaining the quality of assessments.',
      how: "Navigate to 'Question Bank', click 'Add Question', fill in the question details and options, and save it to the bank.",
      link: '/quiz/questions/add',
      permissionView: permissions?.Questions?.View,
      permissionCreate: permissions?.Questions?.Create
    },
    {
      type: 'exam',
      title: 'Create Exam and Exam Time-Table',
      video: 'hiddzyoxdhqt0cdtyynt',
      what: 'This step involves scheduling exams and creating a timetable to manage when and where they will take place.',
      why: 'Exams are a crucial part of the evaluation process, and scheduling them properly ensures that students are prepared and that the institution can manage resources effectively. A clear timetable helps avoid conflicts and ensures a smooth examination process.',
      how: "Go to 'Exams', click 'Create Exam', choose the relevant course, set the exam time and date, and save. You can also create and publish the exam timetable from the same section.",
      link: '/time-table/add',
      permissionView: permissions?.Exam?.View && permissions?.TimeTable?.View,
      permissionCreate: permissions?.Exam?.Create && permissions?.TimeTable?.Create
    },
    {
      type: 'contest',
      title: 'Create Contest',
      video: 'tsxh89yw31jhjzxefwjd',
      what: 'This step involves setting up contests, which may be academic competitions or other challenges related to the learning process.',
      why: 'Contests promote competitive learning and provide additional motivation for students to excel.',
      how: 'Contests are an engaging way to motivate students, foster healthy competition, and encourage excellence. They can also be used to identify and reward top-performing students, enhancing the overall learning experience.',
      link: '/contest/add',
      permissionView: permissions?.Quiz?.View,
      permissionCreate: permissions?.Quiz?.Create
    }
  ];
  return (
    <Grid2 container spacing={4} justifyContent="center" alignItems="center">
      <Grid2 size={12}>
        <Typography variant="h3" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
          Welcome to Vidyalaya LMS,{' '}
          <span style={{ color: theme.palette.primary.main }}>
            {user?.firstName} {user?.lastName}
          </span>
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Box component="img" src={GetStartedBanner} alt="Banner" sx={{ width: '100%', height: 'auto', borderRadius: '16px' }} />
      </Grid2>
      <Grid2 size={12}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', textAlign: 'center', marginBottom: 2 }}>
          Quickstart Guide
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          Getting started with Vidyalaya LMS couldn't be easier. Complete a few steps to facilitate the use of Vidyalaya LMS for you, your
          Instructors, and Students. Start with the steps below to help you understand the platform.
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Box>
          {accordionData
            .filter((item) => item?.permissionView || item?.permissionCreate)
            .map((item, index) => {
              const [videoSources, setVideoSources] = useState([]);
              const [isCompleted, setIsCompleted] = useState(
                user?.onboardingStatus?.find((userItem: any) => userItem?.module === item?.type)
              );
              const [videoAttr, setVideoAttr] = useState<{ expires_at?: number; poster?: string }>({});
              function extractVideoAttributes(html: any) {
                const attributes: { expires_at?: number; poster?: string } = {};

                // Extract poster attribute
                const posterMatch = html.match(/poster=['"]([^'"]+)['"]/);
                if (posterMatch) {
                  attributes.poster = posterMatch[1];
                }

                // Extract expires_at attribute
                const expiresAtMatch = html.match(/expires_at=['"](\d+)['"]/);
                if (expiresAtMatch) {
                  attributes.expires_at = parseInt(expiresAtMatch[1], 10);
                }
                setVideoAttr(attributes);
              }
              useEffect(() => {
                setIsCompleted(user?.onboardingStatus?.find((userItem: any) => userItem?.module === item?.type));
              }, [user]);
              const extractVideoSources = (html: any) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const sources = Array.from(doc.querySelectorAll('source')).map((source) => ({
                  src: source.getAttribute('src'),
                  type: source.getAttribute('type')
                }));
                extractVideoAttributes(html);
                return sources;
              };
              const handleAccordionChange = (index: number, videoId: string) => (event: any, isExpanded: boolean) => {
                setExpandedAccordion(isExpanded ? index : false);

                if (isExpanded && videoSources.length === 0) {
                  setActiveTab(0);
                  // Call the API to fetch the video URL using the videoId
                  getDemoVideo({ videoId: videoId })
                    .then((response) => {
                      const sources: any = extractVideoSources(response?.data?.url);
                      setVideoSources(sources);
                    })
                    .catch((error) => {
                      console.error('Error fetching demo video:', error);
                    });
                }
              };
              return (
                <Box key={index}>
                  {
                    <Accordion
                      expanded={expandedAccordion === index}
                      onChange={handleAccordionChange(index, item.video)}
                      sx={{
                        marginBottom: 2,
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        marginTop: expandedAccordion ? 3 : 0
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ArrowDown2 color="#FFFFFF" />}
                        sx={{
                          bgcolor: 'primary.dark',
                          color: 'white',
                          borderRadius: expandedAccordion === index ? '8px 8px 0 0' : '8px',
                          p: '3px 20px 3px 5px !important',
                          '.MuiAccordionSummary-expandIconWrapper': {
                            order: -1,
                            transition: 'transform 0.3s',
                            transform: expandedAccordion === index ? 'rotate(180deg)' : 'rotate(0deg)'
                          }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {isCompleted ? (
                            <TickCircle size="36" color={theme.palette.primary.lighter} variant="Bulk" style={{ marginRight: '6px' }} />
                          ) : (
                            <Typography
                              variant="h5"
                              sx={{
                                minWidth: '30px',
                                minHeight: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                mr: '6px',
                                bgcolor: 'primary.light'
                              }}
                            >
                              {index + 1}
                            </Typography>
                          )}
                          <Typography variant="h5">{item.title}</Typography>
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails sx={{ padding: 3, borderRadius: '0 0 8px 8px' }}>
                        <Grid2 container spacing={3}>
                          <Grid2 size={{ xs: 12, sm: 5 }}>
                            <video
                              controls
                              {...videoAttr}
                              style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '350px',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                              }}
                            >
                              {videoSources.map((source: any, index) => (
                                <source key={index} src={source?.src} type={source?.type} />
                              ))}
                              <track
                                kind="captions"
                                src="/captions/your-subtitles-file.vtt"
                                srcLang="en"
                                label="English captions"
                                default
                              />
                              Your browser does not support the video tag.
                            </video>
                          </Grid2>
                          <Grid2 size={{ xs: 12, sm: 7 }}>
                            <Tabs
                              value={activeTab}
                              onChange={handleTabChange}
                              // centered
                              indicatorColor="primary"
                              textColor="primary"
                              sx={{ marginBottom: 2 }}
                              variant="scrollable"
                              scrollButtons="auto"
                              key={index}
                            >
                              <Tab label="What is this feature?" />
                              <Tab label="Why should you use it?" />
                              <Tab label="How do you use it?" />
                            </Tabs>
                            <Box sx={{ px: 2, py: 1 }}>
                              {activeTab === 0 && (
                                <Typography variant="body1" color="text.primary" sx={{ marginBottom: 2, textAlign: 'justify' }}>
                                  {item.what}
                                </Typography>
                              )}
                              {activeTab === 1 && (
                                <Typography variant="body1" color="text.primary" sx={{ marginBottom: 2, textAlign: 'justify' }}>
                                  {item.why}
                                </Typography>
                              )}
                              {activeTab === 2 && (
                                <Typography variant="body1" color="text.primary" sx={{ marginBottom: 2, textAlign: 'justify' }}>
                                  {item.how}
                                </Typography>
                              )}
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                  variant="contained"
                                  color={isCompleted ? 'success' : 'primary'}
                                  onClick={() => !isCompleted && CompleteVideo(item.type)}
                                  sx={{
                                    mt: 3,
                                    mr: 2,
                                    textTransform: 'none',
                                    bgcolor: isCompleted ? 'success.main' : 'primary.main',
                                    p: '8px 16px',
                                    cursor: isCompleted ? 'default' : 'pointer',
                                    borderRadius: '20px',
                                    '&:hover': {
                                      bgcolor: isCompleted ? 'success.dark' : 'primary.dark'
                                    }
                                  }}
                                >
                                  {isCompleted ? 'Completed' : 'Complete'}
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={!item?.permissionCreate}
                                  onClick={() => navigate(item.link)}
                                  sx={{
                                    mt: 3,
                                    textTransform: 'none',
                                    bgcolor: 'primary.main',
                                    p: '8px 16px',
                                    borderRadius: '20px',
                                    '&:hover': {
                                      bgcolor: 'primary.dark'
                                    }
                                  }}
                                >
                                  Learn More
                                </Button>
                              </Box>
                            </Box>
                          </Grid2>
                        </Grid2>
                      </AccordionDetails>
                    </Accordion>
                  }
                </Box>
              );
            })}
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default GetStarted;
